import base64 from 'crypto-js/enc-base64'
import { lib } from 'crypto-js/core'
import Utf8 from 'crypto-js/enc-utf8'

export function wordArrayToUint8Array(wordArray) {
  const u8Arr = new Uint8Array(wordArray.sigBytes)
  for (let i = 0; i < wordArray.sigBytes; i++) {
    u8Arr[i] = (wordArray.words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff
  }
  return u8Arr
}

export function uint8ArrayToBase64(u8Arr) {
  const words = []
  let i = 0
  while (i < u8Arr.length) {
    let word = 0
    word =
      (u8Arr[i++] << 24) | (u8Arr[i++] << 16) | (u8Arr[i++] << 8) | u8Arr[i++]
    words.push(word)
  }
  const wordArray = lib.WordArray.create(words, u8Arr.length)
  return base64.stringify(wordArray)
}

export function base64ToUint8Array(base64Str) {
  // 1. Base64 解析为 CryptoJS WordArray
  const wordArray = base64.parse(base64Str)
  return wordArrayToUint8Array(wordArray)
}

export function base64Encode(str) {
  return base64.stringify(Utf8.parse(str))
}
export function base64Decode(str) {
  return Utf8.stringify(base64.parse(str)).toString()
}
